import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Input from "../Input";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import TextArea from "../TextArea";
import classes from "./SignupModal.module.css";
import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";

import PublicIcon from "@mui/icons-material/Public";
import LockIcon from "@mui/icons-material/Lock";
import Button from "../Button/Button";
import { toast } from "react-toastify";
import {
  BaseURL,
  formRegEx,
  formRegExReplacer,
  passwordRegex,
  validateEmail,
} from "../../config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { saveLoginUserData } from "../../redux/auth/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const SignupModal = ({ show, setShow, setShowLogin }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [description, setDescription] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      fullName: fullName,
      email: email,
      location: location,
      password: password,
      passwordConfirm: passwordConfirm,
      description: description,
      role: "customer",
    };
    for (var key in data) {
      if (data[key] == "")
        return toast.warn(
          `${key.replace(formRegEx, formRegExReplacer).trim()} cannot be empty`
        );
    }

    // validate Email
    if (!validateEmail(email)) {
      return toast.warn("Please enter a valid email address");
    }
    if (password.length < 8 || passwordConfirm.length < 8) {
      return toast.warn("type password greater than 7");
    }
    if (password !== passwordConfirm) {
      return toast.warn("password must be same in both fields");
    }

    // if (!passwordRegex.test(password))
    //   return toast.warn(
    //     "Password must contain 1 lowercase and 1 uppercase letter, along with 1 symbol."
    //   );

    setLoader(true);
    const response = await Post(BaseURL("users/signup"), data, null);
    setLoader(false);
    if (response != undefined) {
      setShow(false);
      dispatch(saveLoginUserData(response?.data));
      navigate("/my-cards");
    }
  };

  return (
    <ModalSkeleton show={show} setShow={setShow} className={classes.modalMain}>
      <Container>
        <form onSubmit={handleSubmit} autoComplete={false}>
          <Row className={classes.input_mar}>
            <div className={"text-center"}>
              <h3>Sign Up</h3>
              <p style={{ color: "#929292" }}>
                Please enter your detail here and Sign up Now!
              </p>
            </div>
            <Col md={12}>
              <label>Your Name</label>
              <Input
                className={classes.cus_input}
                leftIcon={<PersonIcon />}
                placeholder={"John Denly"}
                setter={setFullName}
                value={fullName}
              />
            </Col>

            <Col md={6}>
              <label>Email</label>
              <Input
                className={classes.cus_input}
                leftIcon={<MailIcon />}
                placeholder={"johndenly@info.com"}
                setter={setEmail}
                value={email}
              />
            </Col>
            <Col md={6}>
              <label>Location</label>

              <Input
                className={classes.cus_input}
                leftIcon={<PublicIcon />}
                placeholder={"Carribean"}
                setter={setLocation}
                value={location}
              />
            </Col>
            <Col md={6}>
              <label>Password</label>
              <Input
                type={"password"}
                value={password}
                className={classes.cus_input}
                leftIcon={<LockIcon />}
                placeholder={"123*******"}
                setter={setPassword}
              />
            </Col>
            <Col md={6}>
              <label>Confirm Password</label>

              <Input
                type={"password"}
                value={passwordConfirm}
                className={classes.cus_input}
                leftIcon={<LockIcon />}
                placeholder={"123*******"}
                setter={setPasswordConfirm}
              />
            </Col>
            <Col md={12}>
              <label>Description</label>
              <TextArea
                value={description}
                setter={setDescription}
                className={classes.textAreaStyle}
                placeholder={"Tell Me about your..."}
              />
            </Col>
            <div className={classes.lgn_btn_div}>
              <Button disabled={loader} type={"submit"} primary>
                {loader ? "Please Wait..." : "Signup"}
              </Button>
              <p className="mt-2">
                Already have an account?{" "}
                <span
                  className="c-p"
                  onClick={() => {
                    setShowLogin(true);
                    setShow(false);
                  }}
                >
                  Login Now
                </span>
              </p>
            </div>
          </Row>
        </form>
      </Container>
    </ModalSkeleton>
  );
};

export default SignupModal;
